"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var feedback = new _GatewayService["default"]('feedbacktwo');

var getSkills = function getSkills() {
  return feedback.get("rubric/skill");
};

var saveRubricScore = function saveRubricScore(userKey, unitKey, cardstackKey, rubricKey, value) {
  var params = {
    userBusinessKey: userKey,
    unitBusinessKey: unitKey,
    cardstackBusinessKey: cardstackKey,
    rubricBusinessKey: rubricKey
  };
  return feedback.post('rubricScore', value, {
    params: params,
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var saveAllRubricScores = function saveAllRubricScores(userKey, unitKey, cardstackKey, rubrics) {
  return Promise.all(rubrics.map(function (rubric) {
    return saveRubricScore(userKey, unitKey, cardstackKey, rubric.rubricKey, rubric.value);
  }));
};

var fetchRubricScores = function fetchRubricScores(userKey, cardstackKey) {
  return feedback.get("rubricScore/".concat(userKey, "/cardstack/").concat(cardstackKey));
};

var _default = {
  getSkills: getSkills,
  saveRubricScore: saveRubricScore,
  saveAllRubricScores: saveAllRubricScores,
  fetchRubricScores: fetchRubricScores
};
exports["default"] = _default;